import apiRequestService from '@/commonProject/service/apiRequestService';

export default class LineFriendRepository {
    /**
     * LINEフレンド追加情報取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getLineFriendApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/lintag', requestBody, idToken);
        return result;
    }
}
